export const locale = {
  lang: 'en',
  data: {
    MENU: {
      DASHBOARD: 'Dashboard',
      CUSTOMER: 'Cliente',
      CUSTOMERS: 'Clientessssssss',
      SUBSCRIPTIONS: 'Suscripciones'
    }
  }
}
